// Note: The first file of a module here, must also register the module

import "./house-address.component";
import "./house-form.component";
import "./bulk-edit-house.component";
import "./house-list.component";
import "./house-note.component";
import "./house-pane.component";
import "./house.helper";
import "./houses-view.component";
import "./location-houses.component";
import "./view-house.component";
